const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo, 
  permission_routes: state => state.permission.routes,
  page: state => state.other.page,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js